import BeaconAction from '@tencent/beacon-web-sdk';
import { isDebug } from '@/constants/Constants';

// 主要用于自行构造业务漏斗上报监控
const beacon = new BeaconAction({
  appkey: '0WEB0BK0Y941YHM3', // 系统或项目id, 必填
  versionCode: process.env.REACT_APP_VERSION,
  isDebug: false, // 是否开启实时联调, 默认关闭,选填
  strictMode: false, // 严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
  delay: 3000, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
  sessionDuration: 60 * 1000, // session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
});

if (isDebug) {
  window.beacon = beacon;
}

export default beacon;
